import React, { useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { TabMenu } from "primereact/tabmenu";
import MeaPage from "../../../components/MeaPage";
import SecretariatWorkspaceBar from "../components/SecretariatWorkspaceBar";
import MeaPageTitle from "../../../components/MeaPageTitle";
import MeaLoadingContent from "../../../components/MeaLoadingContent";
import MeaDetailField from "../../../components/MeaDetailField";
import MeaDetailCard from "../../../components/MeaDetailCard";
import classesAPI from "../../../services/classes";
import trainingsAPI from "../../../services/trainings";
import StudentsListComponent from "../../trainings/students/components/StudentsListComponent";
import ScheduleListComponent from "../../trainings/schedule/components/ScheduleListComponent";
import SessionsListComponent from "../../trainings/sessions/components/SessionsListComponent";
import { Button } from "primereact/button";

const SecretariatClasseDetailPage = () => {
  const { schoolId, trainingId, classeId } = useParams();
  const navigate = useNavigate();
  const { accessToken } = useAuthContext();

  const [activeItem, setActiveItem] = useState(0);
  const listRef = useRef();

  // Fetch class data
  const classeQuery = classesAPI.GetOne(
    schoolId,
    trainingId,
    accessToken,
    classeId
  );
  const classe = classeQuery?.data?.data;

  // Fetch training data
  const trainingQuery = trainingsAPI.GetOne(schoolId, trainingId, accessToken);
  const training = trainingQuery?.data?.data;

  const tabItems = [
    { label: "Élèves", icon: "pi pi-users" },
    { label: "Programme de la semaine", icon: "pi pi-clock" },
    { label: "Séances de cours", icon: "pi pi-calendar" },
  ];

  const handlePrintForTeachers = () => {
    navigate(`/school/${schoolId}/secretariat/classes/${trainingId}/classe/${classeId}/print-teachers`);
  };

  const customActions = (
    <div className="flex gap-2">
      <Button
        label="Imprimer"
        icon="pi pi-print"
        
        className="mr-2"
        onClick={handlePrintForTeachers}
      > 
      </Button>      
    </div>
  );

  return (
    <MeaPage
      showBackButton={true}
      title={<MeaPageTitle prefix="Classe:" title={classe?.name} />}
      breadcrumb={<SecretariatWorkspaceBar section="classes" training={training} trailing={classe?.name || "Classe"} />}
      customActions={customActions}
    >
      <MeaLoadingContent objectQuery={classeQuery}>
        <MeaDetailCard>
          <MeaDetailField field="Nom de la classe" value={classe?.name} />
          <MeaDetailField
            field="Niveau"
            value={classe?.level?.name || "-"}
          />
          <MeaDetailField
            field="Capacité"
            value={classe?.max_capacity || "-"}
          />
          <MeaDetailField
            field="Nombre d'élèves"
            value={classe?.total_students || "0"}
          />
          <MeaDetailField
            field="Référent(e)"
            value={
              classe?.referent
                ? (classe.referent.name
                  ? classe.referent.name
                  : `${classe.referent.lastname?.toUpperCase() || ""} ${classe.referent.firstname || ""}`.trim())
                : "-"
            }
          />
          <MeaDetailField
            field="Présentation"
            value={classe?.presentation || "-"}
          />
        </MeaDetailCard>

        <div className="mt-5">
          <TabMenu
            model={tabItems}
            activeIndex={activeItem}
            onTabChange={(e) => setActiveItem(e.index)}
          />
          
          {activeItem === 0 && (
            <MeaLoadingContent objectQuery={classeQuery}>
              <StudentsListComponent
                ref={listRef}
                schoolId={schoolId}
                trainingId={trainingId}
                filter={{ classe_id: classe?.id }}
                showAddButton={false}
                showFilterButton={false}
                showSlotChangeColumn={false}
                selectedFields={{
                  level: false,
                  classe: false,
                  passing: false,
                  observation: false,
                  status: true,
                  allergies: true,
                  authorized_take_photo: true,
                  authorized_back_alone: true,
                }}
              />
            </MeaLoadingContent>
          )}

          {activeItem === 1 && (
            <MeaLoadingContent objectQuery={classeQuery}>
              <ScheduleListComponent
                ref={listRef}
                schoolId={schoolId}
                trainingId={trainingId}
                filter={{ classe_id: classe?.id }}
                showAddButton={false}
                showFilterButton={false}
                selectedFields={{
                  classe: false,
                }}
              />
            </MeaLoadingContent>
          )}

          {activeItem === 2 && (
            <MeaLoadingContent objectQuery={classeQuery}>
              <SessionsListComponent
                ref={listRef}
                schoolId={schoolId}
                trainingId={trainingId}
                showAddButton={false}
                showFilterButton={false}
                showAllSessions={true}
                filter={{
                  classe_id: classe?.id,
                  start_date: training?.start_courses_date,
                  end_date: training?.end_courses_date,
                }}
                selectedFields={{
                  presence: true,
                  level: false,
                  classe: false,
                }}
              />
            </MeaLoadingContent>
          )}
        </div>
      </MeaLoadingContent>
    </MeaPage>
  );
};

export default SecretariatClasseDetailPage;
